(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-validate/assets/javascript/pages/redeem/page.js') >= 0) return;  svs.modules.push('/modules/tickets-validate/assets/javascript/pages/redeem/page.js');
"use strict";


const Button = svs.ui.ReactButton;
const {
  PageWrapper
} = svs.ticketsValidate.components;
const Envelope = svs.tur.Envelope;
const branding = svs.tickets.data.templateConfig.branding;
const {
  GamingAccountInfo
} = svs.ticketsValidate.components;
setGlobal('svs.ticketsValidate.pages.Redeem', _ref => {
  var _svs$ticketsValidate$;
  let {
    match
  } = _ref;
  const {
    pathname
  } = ReactRouterDOM.useLocation();
  const ticketInfo = svs.ticketsValidate.data.retailTicketInfo;
  const productType = ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.type;
  const ticketId = match.params.ticketId;
  const shortName = svs.ticketsValidate.utils.getShortNameByTicketId(ticketId);
  const trackType = shortName || productType;
  const {
    state
  } = svs.ticketsValidate.components.context.useValidateContext();
  const image = ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.image;
  const result = state.result;
  const winAmount = (result === null || result === void 0 ? void 0 : result.winAmount) || 0;
  const brand = branding === 'triss' ? 'triss' : 'skrapspel';
  const {
    title,
    preamble
  } = ((_svs$ticketsValidate$ = svs.ticketsValidate.data.config) === null || _svs$ticketsValidate$ === void 0 ? void 0 : _svs$ticketsValidate$.redeemSite) || {};
  const onBuyDigitalTickets = () => {
    svs.ticketgames.ticketUtility.utils.tracking.trackValidateBuyNewTicketsOnlineChosen(trackType);
    const returnUrl = encodeURIComponent("".concat(svs.core.data.baseUrl).concat(pathname));
    svs.utils.url.navigate("/".concat(brand, "/kop-flera/kop/").concat(productType, "?vinst=").concat(winAmount, "&returnUrl=").concat(returnUrl));
  };
  const onBuyPhysicalTickets = () => {
    svs.ticketgames.ticketUtility.utils.tracking.trackValidateBuyNewTicketsOfflineChosen(trackType);
    const returnUrl = encodeURIComponent("".concat(svs.core.data.baseUrl).concat(pathname));
    svs.utils.url.navigate("/".concat(brand, "/vardekod/").concat(productType, "?vinst=").concat(winAmount, "&returnUrl=").concat(returnUrl));
  };
  return React.createElement(PageWrapper, {
    className: "redeem-page u-flex-align-items-center"
  }, React.createElement(React.Fragment, null, React.createElement("div", {
    className: "padding-h-1 margin-bottom-2"
  }, React.createElement("h1", {
    className: "h1"
  }, title), React.createElement("p", {
    className: "p margin-bottom-0 redeem-align-left",
    style: !preamble ? {
      visibility: 'hidden'
    } : undefined
  }, preamble || '\u00A0')), React.createElement(Envelope, {
    branding: branding,
    image: image,
    repeatImage: 1
  }, React.createElement("div", {
    className: "u-flex u-flex-column u-flex-justify-content-center padding-top-1"
  }, React.createElement("h4", {
    className: "h4 margin-bottom-2 validate-font-weight"
  }, "Hur vill du l\xF6sa in din vinst?"), React.createElement(Button, {
    block: true,
    className: "margin-bottom-1",
    focus: true,
    onClick: onBuyDigitalTickets,
    type: "button"
  }, "Skrapa nya lotter digitalt"), React.createElement(Button, {
    block: true,
    focus: true,
    onClick: onBuyPhysicalTickets,
    transparent: true,
    type: "button"
  }, "H\xE4mta nya lotter i butik"))), React.createElement("div", {
    className: "u-flex u-flex-justify-content-center margin-top-2"
  }, React.createElement("div", {
    className: "tickets-validate-envelope-width"
  }, React.createElement(GamingAccountInfo, null)))));
});

 })(window);